import isNil from "lodash.isnil";

export const percent = (value) => {
    if (isNil(value) || Number.isNaN(value)) {
        return "0.00%";
    }
    return `${value.toFixed(2)}%`;
};

export default {
    percent: percent,
    float: (value, places) => value.toFixed(places),
    date: (value) => new Date(value * 1000).toTimeString(),
    lines: (value) => value.join("<br>"),
};
